
import FileUploadMulti from "@/components/files/FileUploadMulti.vue";
import ThgRegistrationUploadCard from "@/components/thg/ThgRegistrationUploadCard.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportStep,
    FileUploadMulti,
    ThgRegistrationUploadCard
  }
})
export default class ThgRegistrationImageUpload extends ReportStepMixin implements IReportStep {
  get getRegistrationImageFront() {
    return ThgCreateModule.registrationImageFront;
  }

  get getRegistrationImageBack() {
    return ThgCreateModule.registrationImageBack;
  }

  screen = ReportScreenEnum.thgregistration;

  header: IReportHeaderData = {
    title: "report.thgRegistration.title",
    description: "report.thgRegistration.description",
    image: AssetEnum.registrationExample
  };

  instruction: IReportInstructionData = {
    title: "report.thgRegistration.title",
    text: "report.thgRegistration.instructionText",
    pictures: [AssetEnum.registrationCorrectInstructions, AssetEnum.registrationIncorrectInstructions],
    example: AssetEnum.registrationExample,
    display: true
  };

  /**
   * @inheritdoc
   */
  get isDone(): boolean {
    if (this.getRegistrationImageFront.length <= 0) {
      return false;
    }

    if (this.getRegistrationImageBack.length <= 0) {
      return false;
    }

    return true;
  }
}
